import Layout from "./src/components/layout";
import React from "react";

// Wrap all pages with the Layout component
export const wrapPageElement = ({ element, props }) => {
  return (
    <Layout>{element}</Layout>
  );
};

// Control scroll behavior on navigation
export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  if (typeof window === "undefined") return true;

  const savedScrollPosition = sessionStorage.getItem("scrollPosition");
  const nextPath = routerProps?.location?.pathname || "";
  const prevPath = prevRouterProps?.location?.pathname || "";

  // Preserve project list position only when closing gallery back to index.
  const isReturningFromGallery =
    Boolean(savedScrollPosition) &&
    prevPath.startsWith("/gallery") &&
    nextPath === "/";

  if (isReturningFromGallery) {
    return false;
  }

  // On mobile, always start at top when switching to main/contact/legal pages.
  const isMobile = window.innerWidth < 768;
  const isMainOrContact =
    nextPath === "/" ||
    nextPath.startsWith("/contact") ||
    nextPath.startsWith("/imprint") ||
    nextPath.startsWith("/privacy");
  if (isMobile && isMainOrContact) {
    return [0, 0];
  }

  return true;
};